import { Injectable } from "@angular/core";
import { Setting } from "../classes/setting";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class SettingsService {
    SettingsSubject: BehaviorSubject<Setting[]> = new BehaviorSubject<Setting[]>(null);

    UpdateSettings = (settings: Setting[]) => {
        this.SettingsSubject.next(settings);
    }
}